import { z } from 'zod';
import { GameModel } from '../../backend/models/gameModel';
import { determinePlayerPositionForSingles, modifyPlayerPositionForDoubles } from '../players/playerPosition';

const requestToAddPointToGame = z.object({
    mode: z.string(),
    game: GameModel,
    playerPositioning: z.array(z.array(z.number())),
    servingSide: z.string(),
    scorer: z.string(),
});

export type RequestToAddPointToGame = z.infer<typeof requestToAddPointToGame>;

const responseAfterAddingPoint = z.object({
    game: GameModel,
    playerPositioning: z.array(z.array(z.number())),
});

export type ResponseAfterAddingPoint = z.infer<typeof responseAfterAddingPoint>;

/*
Logic:
- If doubles:
    - If scorer = servingSide, swap players on serving side
    - If scorer != servingSide, don't swap anything
- If singles:
    - If scorer = servingSide, swap players
    - If scorer != servingSide
        - if scorer points kind is same as receiver points, don't swap
        - if scorer points kind is different to receiver points, swap
 */

export const addPointToGame = (request: RequestToAddPointToGame): ResponseAfterAddingPoint => {
    switch (request.mode) {
        case 'singles':
            return addPointToSingles(request);
        case 'doubles':
            return addPointToDoubles(request);
        default:
            throw new Error('Invalid game mode');
    }
}

const addPointToSingles = (request: RequestToAddPointToGame): ResponseAfterAddingPoint => {
    const gameState = { ...request.game };
    request.scorer === 'left' ? gameState.homePoints += 1 : gameState.guestPoints += 1;
    const newPlayerPositioning = determinePlayerPositionForSingles(
            request.playerPositioning,
            request.scorer,
            [gameState.homePoints, gameState.guestPoints]);
    return { game: gameState, playerPositioning: newPlayerPositioning };
}

const addPointToDoubles = (request: RequestToAddPointToGame): ResponseAfterAddingPoint => {
    const gameState = { ...request.game };
    request.scorer === 'left' ? gameState.homePoints += 1 : gameState.guestPoints += 1;
    const newPlayerPositioning = modifyPlayerPositionForDoubles(request.playerPositioning, request.scorer, request.servingSide);
    return { game: gameState, playerPositioning: newPlayerPositioning };
}